import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useBuilderRunNowLogic } from 'shared-modules/services/hooks/builder';
import { useSummaryInfo } from 'shared-modules/services/hooks';
import { openTechAddToPortfolioFailModal, openTechAddToPortfolioSuccessModal } from '../../../../redux/actions';
import RunNow from '../RunAutoTradeComponents/RunNow';

const TechAddToPortfolio = ({ isOpen, closeModal }) => {
  const dispatch = useDispatch();

  const openSuccessModal = useCallback(
    (orderName) => {
      dispatch(openTechAddToPortfolioSuccessModal({ orderName }));
    },
    [dispatch],
  );

  const openFailModal = useCallback(
    (orderName, fullErrorText) => {
      dispatch(openTechAddToPortfolioFailModal({ orderName, fullErrorText }));
    },
    [dispatch],
  );

  const runNowLogic = useBuilderRunNowLogic({
    isModalOpen: isOpen,
    closeModal,
    handleSuccess: openSuccessModal,
    handleFail: openFailModal,
    isTechBuilder: true,
  });

  const chartData = useSummaryInfo();
  chartData.consumedMargin = runNowLogic.marginRequired.get;

  return (
    <RunNow
      isOpen={isOpen}
      closeModal={closeModal}
      runNowLogic={runNowLogic}
      marginRequired={runNowLogic.marginRequired}
      submitSettings={runNowLogic.techSubmit}
      setsSettings={runNowLogic.sets}
    />
  );
};

TechAddToPortfolio.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default memo(TechAddToPortfolio);
